import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';

import { ThemeBlogCardType, useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export const DEFAULT_THEME_BLOG_CARD = {
  style: 'standard',
  imagePadding: 0,
  textAlignment: 'left',
  borderThickness: 0,
  borderOpacity: 0,
  borderCornerRadius: 0,
  shadowOpacity: 0,
  shadowHorizontalOffset: 0,
  sahdowVerticalOffset: 0,
  shadowBlur: 0,
  limitCharacters: 50,
};

export default function ThemeBlogCardSetting() {
  const builder = useBuilderStore(
    (state) => ({
      theme: state.theme,
      setTheme: state.setTheme,
    }),
    shallow
  );

  const blogCard: ThemeBlogCardType = builder.theme?.blogCard || DEFAULT_THEME_BLOG_CARD;

  const setValue = (newValue: Partial<ThemeBlogCardType>) => {
    builder.setTheme({
      blogCard: { ...blogCard, ...newValue },
    });
  };

  return (
    <div>
      <h3 className='mb-2 mt-4 font-bold'>Style</h3>
      <InputTab
        grid={2}
        defaultValue={blogCard.style}
        options={[
          { label: 'Standard', value: 'standard' },
          { label: 'Card', value: 'card' },
        ]}
        onChange={(val) => setValue({ style: val })}
      />
      <InputSlider
        label='Image Padding'
        value={blogCard.imagePadding}
        max={24}
        min={0}
        onChange={(val) => setValue({ imagePadding: val })}
        rightContent={<div>px</div>}
      />
      {/* <div className='mb-1 mt-4'>Text Alignment</div>
      <InputTab
        defaultValue={blogCard.textAlignment}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(val) => setValue({ textAlignment: val })}
      /> */}
      <div className='mb-2 mt-4'>Color scheme</div>
      <SchemeSetting
        value={blogCard.colorScheme}
        onChange={(theme) => setValue({ colorScheme: theme })}
      />
      <div className='mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
      <h3 className='mb-2 mt-4 font-bold'>Border</h3>
      <InputSlider
        label='Thickness'
        value={blogCard.borderThickness}
        max={12}
        min={0}
        onChange={(val) => setValue({ borderThickness: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Opacity'
        value={blogCard.borderOpacity}
        max={100}
        min={0}
        onChange={(val) => setValue({ borderOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Corner Radius'
        value={blogCard.borderCornerRadius}
        max={40}
        min={0}
        onChange={(val) => setValue({ borderCornerRadius: val })}
        rightContent={<div>px</div>}
      />
      <h3 className='mb-2 mt-4 font-bold'>Shadow</h3>
      <InputSlider
        label='Opacity'
        value={blogCard.shadowOpacity}
        max={100}
        min={0}
        onChange={(val) => setValue({ shadowOpacity: val })}
        rightContent={<div>%</div>}
      />
      <InputSlider
        label='Horizontal Offset'
        value={blogCard.shadowHorizontalOffset}
        max={12}
        min={-12}
        onChange={(val) => setValue({ shadowHorizontalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Vertical Offset'
        value={blogCard.sahdowVerticalOffset}
        max={12}
        min={-12}
        onChange={(val) => setValue({ sahdowVerticalOffset: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Shadow Blur'
        value={blogCard.shadowBlur}
        max={20}
        min={0}
        onChange={(val) => setValue({ shadowBlur: val })}
        rightContent={<div>px</div>}
      />
      <InputSlider
        label='Limit Charecters'
        value={blogCard.limitCharacters || 50}
        max={200}
        min={50}
        onChange={(val) => {
          setValue({ limitCharacters: val });
        }}
      />
    </div>
  );
}
